/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '~/src/components/common/grid/WrappedGrid';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import { API_URL } from '~/src/utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '~/src/static/img/createIcon.svg';

export default function StorageConditionsList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/storage-conditions/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row: { dataItem: { conditionDescription: string; id: string } }): JSX.Element => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/storage-conditions/edit/${dataItem.id}`}>{dataItem?.conditionDescription}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Storage Conditions"
        titleRight="Create"
        onRightHandler={(): void => history.push('/storage-conditions/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="conditionDescription" title="Name" cell={(row) => productNameCell(row, stateRef)} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
